import Others from "@material-symbols/svg-500/rounded/pending.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const OthersIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Others });
	return <Icon />;
};

export default memo(OthersIcon);
